import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import TermsPage from './pages/legal/TermsPage';
import PrivacyPage from './pages/legal/PrivacyPage';
import ShareRidePage from './pages/rides/ShareRidePage';
import MainLayout from './components/common/MainLayout';
import FeedPage from './pages/feed/FeedPage';
import NewsDetailPage from './pages/feed/NewsDetailPage';
import RidesPage from './pages/rides/RidesPage';
import RideDetailsPage from './pages/rides/RideDetailsPage';
import CreateRidePage from './pages/rides/CreateRidePage';
import MyRidesPage from './pages/rides/MyRidesPage';
import FriendsPage from './pages/friends/FriendsPage';
import FriendProfilePage from './pages/friends/FriendProfilePage';
import MessagesPage from './pages/messages/MessagesPage';
import ProfilePage from './pages/profile/ProfilePage';
import BadgesPage from './pages/profile/BadgesPage';
import LoyaltyProgramPage from './pages/profile/LoyaltyProgramPage';
import SettingsPage from './pages/profile/SettingsPage';
import DiscoveryPage from './pages/discover/DiscoveryPage';
import StoresDiscoveryPage from './pages/stores/StoresDiscoveryPage';
import StoreDetailsPage from './pages/stores/StoreDetailsPage';
import ClubsDiscoveryPage from './pages/clubs/ClubsDiscoveryPage';
import ClubDetailsPage from './pages/clubs/ClubDetailsPage';
import MyClubsPage from './pages/clubs/MyClubsPage';
import ClubNewsPage from './pages/clubs/ClubNewsPage';

function AppRoutes() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">{/* Loading... will be translated */}Loading...</div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={!isAuthenticated ? <LoginPage /> : <Navigate to="/" replace />} />
      <Route path="/register" element={!isAuthenticated ? <RegisterPage /> : <Navigate to="/" replace />} />
      <Route path="/forgot-password" element={!isAuthenticated ? <ForgotPasswordPage /> : <Navigate to="/" replace />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/share/ride" element={<ShareRidePage />} />
      <Route
        path="/*"
        element={
          isAuthenticated ? (
            <MainLayout>
              <Routes>
                <Route path="/" element={<Navigate to="/feed" replace />} />
                <Route path="/feed" element={<FeedPage />} />
                <Route path="/feed/news/:newsId" element={<NewsDetailPage />} />
                <Route path="/rides" element={<RidesPage />} />
                <Route path="/rides/create" element={<CreateRidePage />} />
                <Route path="/rides/edit/:rideId" element={<CreateRidePage />} />
                <Route path="/rides/my-rides" element={<MyRidesPage />} />
                <Route path="/rides/:rideId" element={<RideDetailsPage />} />
                <Route path="/friends" element={<FriendsPage />} />
                <Route path="/friends/:friendId" element={<FriendProfilePage />} />
                <Route path="/messages" element={<MessagesPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/profile/badges" element={<BadgesPage />} />
                <Route path="/profile/loyalty" element={<LoyaltyProgramPage />} />
                <Route path="/profile/settings" element={<SettingsPage />} />
                <Route path="/discover" element={<DiscoveryPage />} />
                <Route path="/discover/stores" element={<DiscoveryPage />} />
                <Route path="/stores/:storeId" element={<StoreDetailsPage />} />
                <Route path="/discover/clubs" element={<DiscoveryPage />} />
                <Route path="/clubs/:clubId" element={<ClubDetailsPage />} />
                <Route path="/clubs/my-clubs" element={<MyClubsPage />} />
                <Route path="/clubs/:clubId/news" element={<ClubNewsPage />} />
              </Routes>
            </MainLayout>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
    </Routes>
  );
}

export default AppRoutes;
